import { post } from "~/common/request"

export const listModelFigures = (
  params: API.Model.ModelFigureListParams = {},
) => {
  return post<API.Model.ModelFigureListResponse>("/api/model/list", params)
}
